import Pin from './Pin'
import GoogleMapReact from 'google-map-react'
import { MapContainer, Content, MapInner, X } from './Elements'

const Location = ({ iconSrc, openedMap, setOpenedMap, lat, long }) => {

    const latFloat = parseFloat(lat)
    const longFloat = parseFloat(long)

    const defaultLocation = {
        location: {lat: latFloat, lng: longFloat},
        zoom: 15
    }

    const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY
    
    const handleClose = (e) => {
        if(e.target.id === "container") {
            document.body.style.overflow = "scroll"
            setOpenedMap(!openedMap)
        }
    }

    return (
        <MapContainer id="container" onClick={handleClose}>
            <Content>
                <MapInner id="map">
                    <GoogleMapReact
                    bootstrapURLKeys={{key: apiKey}}
                    defaultCenter={defaultLocation.location}
                    defaultZoom={defaultLocation.zoom}
                    >
                        <Pin iconSrc={iconSrc} />
                    </GoogleMapReact>
                </MapInner>
                <X>X</X>
            </Content>
        </MapContainer>
    )
}

export default Location